import { memo } from 'react';
import { Common } from '@stockbit/ui';
import ReactHtmlParser from 'html-react-parser';

import {
  PreviewPaneContainer,
  PreviewPaneItem,
} from 'global/GlossaryLayout/PreviewPane';
import If from 'global/ErrorHandlers/If';
import { MenuWrapper } from 'global/GlossaryLayout/Wrapper';
import SecondarySpinner from 'global/Loading/SecondarySpinner';

import { IGlossaryTerm } from '../types';
import { DATA_CY_GLOSSARY_PREVIEW } from './__tests__/constant';

const { Text } = Common;

type IPreview = IGlossaryTerm & {
  loading: boolean;
};

function Preview({
  name,
  definition,
  formula,
  explanation,
  loading,
}: IPreview): JSX.Element {
  return (
    <MenuWrapper as="article" data-cy={DATA_CY_GLOSSARY_PREVIEW}>
      <PreviewPaneContainer>
        <SecondarySpinner size="30px" isLoading={loading} />
        <If condition={!loading}>
          <header>
            <Text family="bold" size="20px" mb="35px" mt="10px" as="h2">
              {name}
            </Text>
          </header>

          <If condition={definition}>
            <section>
              <Text family="bold" as="h3">
                Definition
              </Text>
              <PreviewPaneItem>
                {ReactHtmlParser(definition || '')}
              </PreviewPaneItem>
            </section>
          </If>

          <If condition={formula}>
            <section>
              <Text family="bold" as="h3">
                Formula
              </Text>
              <PreviewPaneItem>
                {ReactHtmlParser(formula || '')}
              </PreviewPaneItem>
            </section>
          </If>

          <If condition={explanation}>
            <section>
              <Text family="bold" as="h3">
                Explanation
              </Text>
              <PreviewPaneItem>
                {ReactHtmlParser(explanation || '')}
              </PreviewPaneItem>
            </section>
          </If>
        </If>
      </PreviewPaneContainer>
    </MenuWrapper>
  );
}

export default memo(Preview);
